import { workspaceOrdersFeature, workspaceShopsFeature } from "@stadium/constants/feature-packages";
import { IS_LOCAL_SWAGMAGIC_BUILD, SWAGMAGIC_DOMAIN } from "@constants/env-variables";
import { HOME_PAGE_PATHNAME } from "@constants/routes";

import { matchesUrl } from "@stadium/helpers/dom";
import { generateQueryForRoutePath } from "@stadium/helpers/store";
import { canonicalizeMySpacePath } from "@stadium/helpers/routes";

import { getCatalogNavLinkUrl } from "@stadium/shared/src/helpers/store/links";

export const shouldRedirectToCatalog = ({ currentPath, hostname, catchAll }) => {
  const isSwagmagicHomePage = matchesUrl({
    url: currentPath,
    pathname: [HOME_PAGE_PATHNAME, "/"],
  });
  return (
    (hostname === SWAGMAGIC_DOMAIN || IS_LOCAL_SWAGMAGIC_BUILD) &&
    (isSwagmagicHomePage || !!catchAll)
  );
};

export const getCatalogRedirectUrl = ({
  countryCode,
  lang,
  storeCode,
  storeNumber,
  selectedWorkspaceSlug,
  currentPath,
}) => {
  const queryForRoutePath = generateQueryForRoutePath({
    countryCode: countryCode?.toLowerCase() || "us",
    lang: lang || "en",
    slug: storeCode,
    workspaceSlug: selectedWorkspaceSlug,
    storeNumber,
    isNewRoute: true,
  });
  return getCatalogNavLinkUrl({ queryForRoutePath, isNewRouteEnabled: true });
};

export const getLegacyMySpaceRedirectUrl = ({ currentPath, isNewRoute, selectedWorkspaceSlug }) => {
  const pathParts = currentPath.split("/");
  const storeSlug = isNewRoute ? pathParts[3] : pathParts[4];
  if (!storeSlug) return null;
  return currentPath.replace(storeSlug, `${storeSlug}--${selectedWorkspaceSlug}`);
};

export const getWorkspacePermissions = (workspaceUser, flagEnabled) => {
  return {
    canSendPoints:
      !flagEnabled || workspaceUser?.permissions?.[workspaceOrdersFeature]?.["send_points"],
    canSendItems:
      !flagEnabled || workspaceUser?.permissions?.[workspaceOrdersFeature]?.["send_items"],
    canViewShops: !flagEnabled || workspaceUser?.permissions?.[workspaceShopsFeature]?.["left_nav"],
  };
};

export const rewritePersonalWorkspacePathInUrl = (url) => {
  if (url && typeof url === "object" && typeof url.pathname === "string") {
    const fixedPath = canonicalizeMySpacePath(url.pathname);
    if (fixedPath === url.pathname) return url;
    return { ...url, pathname: fixedPath };
  }
  return canonicalizeMySpacePath(url);
};
